import { createSlice } from '@reduxjs/toolkit';

const INITIAL_STATE = {
  translations: {},
};

const globalsSlice = createSlice({
  name: 'globals',
  initialState: INITIAL_STATE,
  reducers: {
    storeTranslations: (state, action) => {
      state.translations = action.payload;
    },
  },
});

export const { storeTranslations } = globalsSlice.actions;

export default globalsSlice.reducer;
